module.exports = __webpack_public_path__ + "static/media/yourChoice.206a91f7.mp3";